import { withStyles } from '@material-ui/core';
import React from 'react';

const MessageTextTips_ = ({ cantidadVentas, idCountry, classes }) => {
  if (idCountry === 'COL') {
    if (cantidadVentas === 1) {
      return (
        <p className={classes.messageTipsCard}>
          Sigue creciendo y{' '}
          <a
            className={classes.link}
            href="https://empretienda.helpjuice.com/"
            rel="noreferrer"
            target="_blank"
          >
            aprendiendo
          </a>{' '}
          con nuestra plataforma diseñada para emprendedores como tú.
        </p>
      );
    }

    return (
      <p className={classes.messageTipsCard}>
        Mantén el enfoque en tus objetivos y haz crecer tu emprendimiento con
        nuestra plataforma.
      </p>
    );
  }

  if (cantidadVentas === 1) {
    return (
      <p className={classes.messageTipsCard}>
        Seguí creciendo y{' '}
        <a
          className={classes.link}
          href="https://empretienda.helpjuice.com/"
          rel="noreferrer"
          target="_blank"
        >
          aprendiendo
        </a>{' '}
        con nuestra plataforma diseñada para emprendedores como vos.
      </p>
    );
  }

  return (
    <p className={classes.messageTipsCard}>
      En{' '}
      <a
        className={classes.link}
        href="https://empretienda.helpjuice.com/"
        rel="noreferrer"
        target="_blank"
      >
        nuestros tutoriales
      </a>{' '}
      encontrarás herramientas para hacer crecer tu emprendimiento.
    </p>
  );
};

const styles = () => ({
  messageTipsCard: {
    color: '#6F6F6F',
    fontWeight: '400',
    lineHeight: '24px',
    fontSize: '1.12rem',
  },
  link: {
    color: '#53B755',
    textDecoration: 'underline !important',
  },
});

export const MessageTextTips = withStyles(styles)(MessageTextTips_);
